module.exports = __webpack_public_path__ + "img/linkyimo-ai.dbd2ac03.png";